import posthog from "posthog-js";

posthog.init("phc_xZJwcNBsTSBBby8qmrU62e6zKXZj2xHnYZQvGXoBuJr9", {
  api_host: "https://us.i.posthog.com",
  defaults: "2026-01-30",
  capture_exceptions: true,
  debug: process.env.NODE_ENV === "development",
});
